import { BiTrash } from "react-icons/bi";
import { useForm } from "react-hook-form";
import { useState, useEffect } from "react";

const Contacto = ({
  remover,
  handleFullNameScaleChange,
  handleMailScale,
  index,
  indexArray,
  formData,
}) => {
  indexArray += 1;

  const [fullNameValue, setFullNameValue] = useState("");
  const [mailValue, setMailValue] = useState("");

  const {
    register,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    setFullNameValue(
      formData.full_nameScale[index]
        ? formData.full_nameScale[index][indexArray]
        : ""
    );
    setMailValue(
      formData.mailScale[index] ? formData.mailScale[index][indexArray] : ""
    );
    // console.log(
    //   `===================index del nivel :${index}=================`
    // );
    // console.log("Index del contacto: " + indexArray);
    // console.log("====================================");
  }, [formData, indexArray]);

  return (
    <>
      <tr>
        <td>
          {/* nombre completo */}
          <div className="form-group">
            <input
              type="text"
              className="form-control"
              id={`full_nameScale`}
              name={`full_nameScale`}
              value={fullNameValue}
              placeholder="Nombre completo"
              {...register(`full_nameScale`, {
                pattern: {
                  value: /^[a-zA-ZáéíóúÁÉÍÓÚüÜñÑ\s]+$/,
                  message: "Ingresa un nombre válido",
                },
                maxLength: {
                  value: 255,
                  message: "El nombre debe tener como máximo 255 caracteres",
                },
                minLength: {
                  value: 3,
                  message: "El nombre debe tener al menos 3 caracteres",
                },
              })}
              onChange={(e) => {
                handleFullNameScaleChange(index, indexArray, e.target.value);
              }}
            />
            {errors[`full_nameScale`]?.type === "pattern" && (
              <small className="help-block">
                {errors[`full_nameScale`].message}
              </small>
            )}
            {errors[`full_nameScale`]?.type === "minLength" && (
              <small className="help-block">
                {errors[`full_nameScale`].message}
              </small>
            )}
            {errors[`full_nameScale`]?.type === "maxLength" && (
              <small className="help-block">
                {errors[`full_nameScale`].message}
              </small>
            )}
          </div>
        </td>
        <td>
          {/* Correo */}
          <div className="form-group">
            <input
              type="text"
              className="form-control"
              id={`mailScale`}
              name={`mailScale`}
              value={mailValue}
              placeholder="Correo"
              {...register(`mailScale`, {
                pattern: {
                  value: /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/,
                  message: "Ingresa un correo electrónico válido",
                },
              })}
              onChange={(e) => {
                handleMailScale(index, indexArray, e.target.value);
              }}
            />
            {errors[`mailScale`]?.type === "pattern" && (
              <small className="help-block">
                {errors[`mailScale`].message}
              </small>
            )}
          </div>
        </td>
        <td>
          {/* Boton eliminar */}
          <button
            style={{
              backgroundColor: "#dc3545",
              color: "white",
              borderRadius: "50%",
              width: "30px",
              height: "30px",
              border: "none",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
            }}
            type="button"
            onClick={() => remover(index, indexArray)}
          >
            <BiTrash />
          </button>
        </td>
      </tr>
    </>
  );
};

export default Contacto;
